import { render, staticRenderFns } from "./xhs-preview.vue?vue&type=template&id=022ed98d"
import script from "./xhs-preview.vue?vue&type=script&lang=js"
export * from "./xhs-preview.vue?vue&type=script&lang=js"
import style0 from "./xhs-preview.vue?vue&type=style&index=0&id=022ed98d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports